function methodsAfterQtyUpdate() {
  const pixTotalId = document.getElementById("pix-price");
  const cartaoTotalId = document.getElementById("cartao-price");
  let cartaoPricePr = 0;
  let pixPricePr = 0;
  const cartItemsPr = document.querySelectorAll(".cart-item");
  cartItemsPr.forEach(item => {
    cartaoPricePr = cartaoPricePr + Number(item.dataset.cartaoPrice);
    pixPricePr = pixPricePr + Number(item.dataset.pixPrice);
  })
  cartaoTotalId.innerText = (Number(cartaoPricePr) / 100.00).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
  pixTotalId.innerText = (Number(pixPricePr) / 100.00).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
}

CartItems.prototype.renderContents = function (parsedState, lineItem, name) {
  const cartDrawerWrapper = document.querySelector('cart-drawer');
  // const cartFooter = document.getElementById('main-cart-footer');
  const cartPage = document.getElementById('main-cart');
  if(cartPage) {
    cartPage.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartPageBox = cartPage.getBoundingClientRect();
    if(!(cartPageBox.top < window.innerHeight && cartPageBox.bottom >= 0)) {
      // Scroll top to the cart page content
      cartPage.scrollIntoView({ behavior: "smooth" });
    }
  }
  
  // if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
  this.getSectionsToRender().forEach((section => {
    const elementToReplace = document.getElementById(section.section).querySelector(section.selector) || document.getElementById(section.section);
    if(elementToReplace) {
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }  
  }));
  
  if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
    cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
  } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
  } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
  }
  
  this.updateProductRecommendation();
  const cartItems = document.querySelectorAll(".cart-item");
  cartItems.forEach(item => {
    cartaoPrice = cartaoPrice + Number(item.dataset.cartaoPrice);
    pixPrice = pixPrice + Number(item.dataset.pixPrice);
    cart[item.dataset.varId] = Number(item.querySelector(".quantity__input").value);
  })
}

CartItems.prototype.updateQuantity = function (line, quantity, name) {
  this.enableLoading(line);

  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname
  });

  const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
  fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      this.renderContents(parsedState, lineItem, name);
      document.dispatchEvent(new CustomEvent('afterUpdateQuantity'));
      errors.classList.add('hidden');
    }).catch(() => {
      errors.classList.remove('hidden');
      errors.querySelector('span').textContent = window.cartStrings.error;
    }).finally(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      this.disableLoading();
      methodsAfterQtyUpdate();
    });


  
}